/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 解锁文惠劵
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  couponId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/unlock-culture-coupons/${couponId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
